module.exports = __webpack_public_path__ + "static/media/theta.4aec318c.svg";